module.exports = __webpack_public_path__ + "img/flag_br.fe1fd041.svg";